import common from "./common.json";
import loginForm from "./loginForm.json";
import workTypes from "./workTypes.json";
import userTypes from "./userTypes.json";
import userAuthorization from "./userAuthorization.json";
import userDetail from "./userDetail.json";
import userPage from "./userPage.json";
import smsTrackingOptions from "./smsTrackingOptions.json";
import statisticsContainer from "./statisticsContainer.json";
import statisticsPage from "./statisticsPage.json";
import stats from "./stats.json";
import subcompanyDetail from "./subcompanyDetail.json";
import textBoxFormModal from "./textBoxFormModal.json";
import timeRangeOptionsStatistics from "./timeRangeOptionsStatistics.json";
import transferModal from "./transferModal.json";
import shiftRequest from "./shiftRequest.json";
import shiftScore from "./shiftScore.json";
import shiftSuggestion from "./shiftSuggestion.json";
import singleMarkerMap from "./singleMarkerMap.json";
import slotCourierDedication from "./slotCourierDedication.json";
import slotDetailCard from "./slotDetailCard.json";
import slotOrderOptions from "./slotOrderOptions.json";
import shiftCompliance from "./shiftCompliance.json";
import shiftManagement from "./shiftManagement.json";
import shiftReportStatuses from "./shiftReportStatuses.json";
import pools from "./pools.json";
import profilePage from "./profilePage.json";
import proofModal from "./proofModal.json";
import proofOfDelivery from "./proofOfDelivery.json";
import reportPage from "./reportPage.json";
import selectReasons from "./selectReasons.json";
import orderPage from "./orderPage.json";
import orderReportPage from "./orderReportPage.json";
import orderSourceStatsWidget from "./orderSourceStatsWidget.json";
import orderStatuses from "./orderStatuses.json";
import orderTimeStatsWidget from "./orderTimeStatsWidget.json";
import paymentManagement from "./paymentManagement.json";
import paymentMethodStatsWidget from "./paymentMethodStatsWidget.json";
import paymentTypes from "./paymentTypes.json";
import activationSubSteps from "./activationSubSteps.json";
import options from "./options.json";
import orderCountStatsWidget from "./orderCountStatsWidget.json";
import orderDetail from "./orderDetail.json";
import objectionStatuses from "./objectionStatuses.json";
import activationSteps from "./activationSteps.json";
import activationPhases from "./activationPhases.json";
import newUser from "./newUser.json";
import objectionDetail from "./objectionDetail.json";
import mapCourierStatuses from "./mapCourierStatuses.json";
import mapStatisticTitles from "./mapStatisticTitles.json";
import mergeOptions from "./mergeOptions.json";
import multipleSelect from "./multipleSelect.json";
import newCompany from "./newCompany.json";
import newCourier from "./newCourier.json";
import newPassword from "./newPassword.json";
import newRequest from "./newRequest.json";
import heatMap from "./heatMap.json";
import hourlyOrderStatsWidget from "./hourlyOrderStatsWidget.json";
import imageEditorModal from "./imageEditorModal.json";
import integrations from "./integrations.json";
import lastRespondedByStatuses from "./lastRespondedByStatuses.json";
import locationCheckOptions from "./locationCheckOptions.json";
import dayOff from "./dayOff.json";
import dayOffStatuses from "./dayOffStatuses.json";
import days from "./days.json";
import deliveryStatuses from "./deliveryStatuses.json";
import deliveryVerificationOptions from "./deliveryVerificationOptions.json";
import durationStatsWidget from "./durationStatsWidget.json";
import dynamicPriceOptions from "./dynamicPriceOptions.json";
import forgotPasswordModal from "./forgotPasswordModal.json";
import cutOffOptions from "./cutOffOptions.json";
import dailyOrderStatsWidget from "./dailyOrderStatsWidget.json";
import datePeriodOptions from "./datePeriodOptions.json";
import courierPage from "./courierPage.json";
import courierResetPasswordModal from "./courierResetPasswordModal.json";
import courierStatisticsReportPage from "./courierStatisticsReportPage.json";
import courierStatisticsTable from "./courierStatisticsTable.json";
import courierStatusUpdateModal from "./courierStatusUpdateModal.json";
import courierStatuses from "./courierStatuses.json";
import courierTypes from "./courierTypes.json";
import courierDedication from "./courierDedication.json";
import courierDetail from "./courierDetail.json";
import courierFileUploadModal from "./courierFileUploadModal.json";
import courierLogTable from "./courierLogTable.json";
import courierStatusLogTable from "./courierStatusLogTable.json";
import courierStatusLogTypes from "./courierStatusLogTypes.json";
import personalCompanySetupStatus from "./personalCompanySetupStatus.json";
import courierMapTab from "./courierMapTab.json";
import communicationPreferences from "./communicationPreferences.json";
import companyDetail from "./companyDetail.json";
import companyPage from "./companyPage.json";
import companyUserSelect from "./companyUserSelect.json";
import changeStatusList from "./changeStatusList.json";
import changeFileUploadList from "./changeFileUploadList.json";
import changePasswordForm from "./changePasswordForm.json";
import companyWorkingTypes from "./companyWorkingTypes.json";
import codPayment from "./codPayment.json";
import subCompanyPricing from "./subCompanyPricing.json";
import courierContracts from "./courierContracts.json";
import pagePermissions from "./pagePermissions.json";
import tickets from "./tickets.json";
import applications from "./applications.json";
export default {
    common,
    codPayment,
    subCompanyPricing,
    loginForm,
    workTypes,
    userTypes,
    userAuthorization,
    userDetail,
    userPage,
    smsTrackingOptions,
    statisticsContainer,
    statisticsPage,
    stats,
    subcompanyDetail,
    textBoxFormModal,
    timeRangeOptionsStatistics,
    transferModal,
    shiftRequest,
    shiftScore,
    shiftSuggestion,
    singleMarkerMap,
    slotCourierDedication,
    slotDetailCard,
    slotOrderOptions,
    shiftCompliance,
    shiftManagement,
    shiftReportStatuses,
    pools,
    profilePage,
    proofModal,
    proofOfDelivery,
    reportPage,
    selectReasons,
    orderPage,
    orderReportPage,
    orderSourceStatsWidget,
    orderStatuses,
    orderTimeStatsWidget,
    paymentManagement,
    paymentMethodStatsWidget,
    paymentTypes,
    activationSubSteps,
    options,
    orderCountStatsWidget,
    orderDetail,
    objectionStatuses,
    activationSteps,
    activationPhases,
    newUser,
    objectionDetail,
    mapCourierStatuses,
    mapStatisticTitles,
    mergeOptions,
    multipleSelect,
    newCompany,
    newCourier,
    newPassword,
    newRequest,
    heatMap,
    hourlyOrderStatsWidget,
    imageEditorModal,
    integrations,
    lastRespondedByStatuses,
    locationCheckOptions,
    dayOff,
    dayOffStatuses,
    days,
    deliveryStatuses,
    deliveryVerificationOptions,
    durationStatsWidget,
    dynamicPriceOptions,
    forgotPasswordModal,
    cutOffOptions,
    dailyOrderStatsWidget,
    datePeriodOptions,
    courierPage,
    courierResetPasswordModal,
    courierStatisticsReportPage,
    courierStatisticsTable,
    courierStatusUpdateModal,
    courierStatuses,
    courierTypes,
    courierDedication,
    courierDetail,
    courierFileUploadModal,
    courierLogTable,
    courierStatusLogTable,
    courierStatusLogTypes,
    personalCompanySetupStatus,
    courierMapTab,
    communicationPreferences,
    companyDetail,
    companyPage,
    companyUserSelect,
    changeStatusList,
    changeFileUploadList,
    changePasswordForm,
    companyWorkingTypes,
    courierContracts,
    pagePermissions,
    tickets,
    applications
};
